import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * MTB Mint palette — the design-system v2 brand tuple. Mirrors the
 * `[data-palette='brand']` block in the Storefront Shell design bundle
 * (`mtb-storefront/project/theme.css` lines ~292–319). Mantine's
 * `primaryShade` is split so dark mode picks up the lighter mint (5) and
 * light mode stays on the saturated teal (6).
 */
const brand: MantineColorsTuple = [
  '#effaf6',
  '#d6f1e6',
  '#a9e5cf',
  '#76d8b5',
  '#4dcca0',
  '#2bc28e',
  '#0fa882',
  '#0a8869',
  '#086c55',
  '#065543',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 5 },
  colors: { brand },
  defaultRadius: 'md',
  fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
  },
});
